import Fetch from "../services/Fetch";
import snackbarService from "../services/ui-messaging/SnackbarService";

export type setter = (content: any) => void;

export default (path: string, setter: setter) => () => {
  const getDoc = async () => {
    try {
      const resp = await Fetch(path);
      const data = await resp.json();
      setter(data);
    } catch (err) {
      snackbarService.error(err);
    }
  };
  getDoc();
};
